import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import VueBarcode from 'vue-barcode'
import VueElementLoading from 'vue-element-loading'
import moment from 'moment'
import CryptoJS from 'crypto-js'
import {
	Validator
} from 'vee-validate'
// import Printd from 'printd'
export default {
	name: 'po',
	components: {
		Paginate,
		VueElementLoading,
		'barcode': VueBarcode
	},

	data: function () {
		return {
			shipmentDetailsCount: '',
			isLoading: false,
			loginwarehouseid: 0,
			loginClientUserId: 0,
			poid: '',
			pono: '',
			urlclientid: '',
			urlwarehouseid: '',
			qcpackingDetails: [],
			packingQCDetails: 0,
			// initialize form field

		}
	}, // end data
	created: function () { },
	filters: {
		moment: function (date) {
			return moment(date).format('DD-MM-YYYY');
		},

	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = userdetail.userid;
		var loginuseremail = userdetail.email;
		this.loginwarehouseid = userdetail.warehouseid;
		this.loginClientUserId = userdetail.clientid;
		this.getorderDetails()
		this.pagenoship = 0
		this.pagenoorder = 0;
	},

	methods: {
		dateFormatDetail(date) {
			if (!date) return '';
			return moment(date).format('LLLL');
		},
		rejectReason(reason) {
			if (reason == "") {
				return "--";
			} else {
				if (reason.length == 0) {
					return '';
				} else {
					return reason.join();
				}
			}
		},
		toUpper(str) {
			if (str !== null && str !== undefined) {
				return str.charAt(0).toUpperCase() + str.slice(1);
			} else {
				return '--'
			}

		},
		getorderDetails() {

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pono = this.$route.params.poid
			this.urlclientid = this.loginClientUserId ? this.loginClientUserId : this.$route.query.clientid
			this.urlwarehouseid = this.loginwarehouseid ? this.loginwarehouseid : this.$route.query.warehouseid
			this.poid = this.pono;
			this.isLoading = true;
			this.input = ({
				pono: this.pono,
				clientid: this.urlclientid,
				warehouseid: this.urlwarehouseid,
				type: "OutQCDetails"
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getSingleOrderDetailsUpdatedForTab',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.qcpackingDetails = result.data.data.qcpackingDetails;
					this.packingQCDetails = this.qcpackingDetails.length;
					this.isLoading = false;
				},
					error => {
						console.error(error)
					})
		},





	} // end methods
}



// WEBPACK FOOTER //
// ./src/views/components/orderdetailstab/outQCdetails/outQCdetails.component.js